import { render } from "./NotifItems.vue?vue&type=template&id=9a0f0ada"
import script from "./NotifItems.vue?vue&type=script&lang=js"
export * from "./NotifItems.vue?vue&type=script&lang=js"

import "./NotifItems.vue?vue&type=style&index=0&id=9a0f0ada&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__